<template>
<div id="app">

    <toolbar v-bind:selection="toolbar" title="Ciclos de reina" />


    <div class="card">
        <div class="info-item">
            <div>

                <p><b>{{detailqueen.name}}</b></p>

                <p class="text-small">{{ detailqueen.description }}</p>

                <p v-if="detailqueen.namecolmenar!=null">Colmena <b>{{detailqueen.namecolmenar}}</b> en <b>{{detailqueen.number}}</b></p>


                <infoqueen
                           v-bind:marked="detailqueen.marked"
                           v-bind:year="detailqueen.year"
                           v-bind:race="detailqueen.race"
                           v-bind:origin="detailqueen.origin"
                ></infoqueen>

            </div>

        </div>

    </div>




    <div class="content">


        <div v-if="!result.length" class="card">
            No hay ciclos para esta reina.<br/><br/>
        </div>

        <div v-else>

            <div class="vsm-header">
                CICLOS DE LA REINA
            </div>
            <ul v-for="queen_cycle in result" :key="queen_cycle.id">
                <li class="card" v-bind:id="'ciclo-reina-'+queen_cycle.id">
                    <div class="info-item">

                        <div class="info-item-list-left">
                            <p v-if="queen_cycle.color==='sin marcar'" class="text-red">Sin marcar</p>
                            <span v-if="queen_cycle.date!=''" v-bind:class="'badge badge-'+queen_cycle.color">{{ queen_cycle.date.split("-").reverse().join('-') }}</span>&nbsp;
                            <span class="let">{{ queen_cycle.cycle }}</span>, <span class="let">{{ queen_cycle.state }}</span>
                        </div>

                        <div class="info-item-list-right">
                            <a v-bind:href="'#/ciclo-reina-editar/' + queen_cycle.id">
                                <v-icon small>edit</v-icon>
                            </a>
                            <button v-on:click="deleteElement(queen_cycle.id)">
                                <v-icon small>delete</v-icon>
                            </button>
                        </div>
                    </div>
                </li>
            </ul>

        </div>



    </div>


    <!--div-- class="btn-fixed">
        <a v-bind:href="'#/ciclo-reina-nueva/'+detailqueen.id" class="btn btn-yellow">NUEVO CICLO</a>
    </div-->

    <!--router-link v-bind:to="'/ciclo-reina-nueva/'+detailqueen.id" class="btn-fixed btn btn-yellow bottom20">
        NUEVO CICLO
    </router-link-->

</div>



</template>

<script>
import auth from "@/libs/auth"

import toolbar from "@/components/Toolbar"

import lastcyclequeen from "@/components/queens/lastcyclequeen"
import infoqueen from "@/components/queens/infoqueen"

import axios from "axios";
export default {

  name: 'ciclos-reina',
  components: {toolbar,lastcyclequeen,infoqueen},

    data() {
        return {

              toolbar: {
                return: '1',
                icons: [
                  { text: 'Añadir', href:'ciclo-reina-nueva/'+this.$route.params.id },
                  { text: 'Cancelar', href:'ciclos-reina/'+this.$route.params.id }
                ],
              },
            detailqueen: null,
            result: null,
            resp: null,
        }
  },
  created() {
    auth.getUserLogged()

    var that = this

    axios.get("https://appws.panimiel.com/new/index.php/api/queens/"+this.$route.params.id).then((detailqueen) => {
      that.detailqueen = detailqueen.data

    })

    axios.get("https://appws.panimiel.com/new/index.php/api/queens_cycle/"+this.$route.params.id).then((result) => {
      that.result = result.data

    })

  },
   methods:{
        deleteElement(id) {
            if(confirm('¿Estás seguro de eliminar este ciclo de reina?'))
            axios.delete('https://appws.panimiel.com/new/index.php/api/queens_cycle/'+id)
              .then(resp => {

              this.resp = resp.data
              var x = document.getElementById("ciclo-reina-"+id);
              x.style.display = "none";
            })
        }
   }


};


</script>

<style scoped lang="scss">
</style>